/** 
 *   登录页面 API
 */
import { post } from '@/untils/axios.js'

//登录

export const login = params => post('login', params)